const TYPES = { 
    AuthStore : Symbol.for("AuthStore"),
    RemoteAPI : Symbol.for("RemoteAPI"),
    ParkingDataStore : Symbol.for("ParkngDataStore")
};

export {TYPES}